export default "__VITE_ASSET__Ct4IUcvs__"